<div class="main-container flex-centered" *ngIf="isLoadingSpinnerVisible">
    <app-loading-spinner></app-loading-spinner>
</div>

<div *ngIf="isViewInitialized" class="main-container">
    <app-dashboard-panel-header
        [title]="title"
        [isPreview]="isPreview"
        (onDeleteClicked)="handleDeleteClicked()"
    ></app-dashboard-panel-header>
    <div
        #mimicContainer
        data-cy="dashboard-mimic-tab-mimic"
        class="content-container"
        [ngStyle]="mainContainerStyle"
    >
        <lib-mimic-viewer
            *ngIf="selectedMimic"
            [mimic]="selectedMimic"
            [width]="maxWidth"
            [height]="maxHeight"
            [elementsSettings]="elementsSettings"
            [channelsUpdateObservable]="getUpdatedTagValue"
            [defaultColors]="defaultColors"
            [vesselId]="vesselId"
        >
        </lib-mimic-viewer>
    </div>
</div>
